// modules/survey/routes.js
import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import LandingPage from './submodules/landingPage/LandingPage';
import QNA from './submodules/QNA/QNA';
import Thankyou from './submodules/thank-you/Thankyou';
import ReportPreview from './submodules/report/ReportPreview';
import ReportPuck from './submodules/report/ReportPuck';
import { NotFound } from './submodules/not-found/NotFound';
// import SurveyLandingPage from './submodules/surveyLandingPage/SurveyLandingPage';
// Import components for settings routes



const CLIENT_HOME_HOST = "socsurvey.tatacommunications.com";
const CLIENT_HOME_SURVEY = "b6420220-5ba7-11ef-b484-6dfb5d512f67";

const ClientHomeRedirect = () => {
  if (window.location.hostname === CLIENT_HOME_HOST) {
    return <Navigate to={`/${CLIENT_HOME_SURVEY}`} replace />;
  }
  return <Navigate to={"not-found"} replace />;
};

const SurveyRoutes = [
  <Route exact path="/:survey_id" element={<LandingPage />}> </Route>,
  // <Route exact path="/survey-landing-page" element={<SurveyLandingPage />}> </Route>,
  <Route exact path="/qna/:survey_id/:ss_id" element={< QNA />}> </Route>,
  <Route exact path="/thank-you/:survey_id/:ss_id" element={< Thankyou />}> </Route>,
  <Route exact path="/report-preview/:survey_id/:ss_id/:srid/:isPreview?/:device?" element={< ReportPreview />}> </Route>,
  <Route exact path="/report/:survey_id/:ss_id/:srid/:isPreview?/:device?" element={< ReportPuck />}> </Route>,
  <Route exact path="/not-found/" element={< NotFound />}> </Route>,
  <Route exact path="/" element={<ClientHomeRedirect />}> </Route>,
  <Route exact path="*" element={<Navigate to={'not-found'}> </Navigate>}> </Route>

];

export default SurveyRoutes;
